'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ModalContext = require('./ModalContext.js');
var Modal = require('./Modal.js');
var ModalPage = require('./ModalPage.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

/**
 * This component has been deprecated. Please see modal-v2 (<Modal>, <ChildModal>, <useModal>)
 * @deprecated
 */
var ModalManager = function (_a) {
    var children = _a.children;
    var _b = react.useState([]), modals = _b[0], setModals = _b[1];
    var _c = react.useState(false), isTransitioning = _c[0], setIsTransitioning = _c[1];
    var _d = react.useState(''), overflow = _d[0], setOverflow = _d[1];
    var _e = react.useState(false), isLoader = _e[0], setIsLoader = _e[1];
    var handleTransitions = function () {
        setIsTransitioning(true);
        setTimeout(function () {
            setIsTransitioning(false);
        }, 1000); // this timeout needs to match animation slidein slideout
    };
    /**
     * @deprecated since alloy 1.6. Use addModalWithOptions instead
     */
    var addModal = react.useCallback(function (jsx, title, isRequired, focusSelector) {
        if (isRequired === void 0) { isRequired = false; }
        if (focusSelector === void 0) { focusSelector = ''; }
        if (jsx) {
            handleTransitions();
            setModals(function (prevModal) { return tslib.__spreadArray(tslib.__spreadArray([], prevModal, true), [
                { jsx: jsx, title: title, isRequired: isRequired, focusSelector: focusSelector }
            ], false); });
        }
    }, []);
    var addModalWithOptions = react.useCallback(function (jsx, options) {
        if (jsx) {
            handleTransitions();
            setModals(function (prevModal) { return tslib.__spreadArray(tslib.__spreadArray([], prevModal, true), [tslib.__assign({ jsx: jsx }, options)], false); });
        }
    }, []);
    var hideOverflow = react.useCallback(function () { return setOverflow(''); }, []);
    var showOverflow = react.useCallback(function () { return setOverflow('overflow-visible'); }, []);
    var hideScroll = react.useCallback(function () { return setOverflow('overflow-hidden'); }, []);
    var showLoader = react.useCallback(function () {
        hideScroll();
        setIsLoader(true);
    }, [hideScroll]);
    var hideLoader = react.useCallback(function () {
        hideOverflow(); //Show scroll
        setIsLoader(false);
    }, [hideOverflow]);
    var removeCurrentModal = react.useCallback(function (timeout) {
        if (timeout === void 0) { timeout = 0; }
        hideOverflow();
        handleTransitions();
        setTimeout(function () {
            setModals(function () {
                var newArray = tslib.__spreadArray([], modals, true);
                newArray.pop();
                return newArray;
            });
        }, timeout);
    }, [hideOverflow, modals]);
    var closeAllModals = react.useCallback(function () {
        hideOverflow();
        setModals([]);
    }, [hideOverflow]);
    var getPreviousPageName = function (index) {
        return modals[index - 1] ? modals[index - 1].title : null;
    };
    var getIsRequired = function () {
        return modals.filter(function (modal) { return modal.isRequired; }).length > 0;
    };
    var context = react.useMemo(function () { return ({
        addModal: addModal,
        addModalWithOptions: addModalWithOptions,
        closeAllModals: closeAllModals,
        hideLoader: hideLoader,
        hideOverflow: hideOverflow,
        hideScroll: hideScroll,
        isLoader: isLoader,
        modals: modals,
        overflow: overflow,
        removeCurrentModal: removeCurrentModal,
        showOverflow: showOverflow,
        showLoader: showLoader
    }); }, [
        addModal,
        addModalWithOptions,
        closeAllModals,
        hideLoader,
        hideOverflow,
        hideScroll,
        isLoader,
        modals,
        overflow,
        removeCurrentModal,
        showOverflow,
        showLoader
    ]);
    return (jsxRuntime.jsxs(ModalContext.default.Provider, tslib.__assign({ value: context }, { children: [modals.length > 0 && (jsxRuntime.jsx(Modal.default, tslib.__assign({ isTransitioning: isTransitioning, isRequired: getIsRequired() }, { children: modals.map(function (_a, index) {
                    var jsx = _a.jsx, title = _a.title, rest = tslib.__rest(_a, ["jsx", "title"]);
                    return (jsxRuntime.jsx(ModalPage.default, tslib.__assign({ isActiveModal: index === modals.length - 1, isChildModal: index > 0, isTransitioning: isTransitioning, pageName: title, previousPage: getPreviousPageName(index) }, rest, { children: jsx }), title || index));
                }) }))), children] })));
};
ModalManager.propTypes = {
    children: PropTypes__default.default.node
};
var ModalManager$1 = ModalManager;

exports.default = ModalManager$1;
//# sourceMappingURL=ModalManager.js.map
